<template>
  <DefInsertTildaSlider v-if="result.html" :result="result.html" />
  <DefVideo
    v-else-if="result.video"
    :result="result.video"
    :loop="true"
    class="def-banner-media"
    :priority="priority"
  />
  <DefImg
    v-else-if="result.picture"
    :result="result.picture"
    class="def-banner-media"
    :priority="priority"
  />
  <DefPicture
    v-else
    :result="result.animation || result.pictures"
    class="def-banner-media"
    :priority="priority"
  />
</template>

<script lang="ts" setup>
import { IPicture, IPictures, IVideo } from '@/interfaces';
import DefVideo from '@components/Def/DefVideo/DefVideo.vue';
import DefImg from '@components/Def/DefImg/DefImg.vue';
import DefPicture from '@components/Def/DefPicture/DefPicture.vue';
import DefInsertTildaSlider from '@components/Def/DefInsertTilda/DefInsertTildaSlider.vue';

const props = defineProps<{
  result: {
    video?: IVideo;
    pictures?: IPictures;
    animation?: IPictures;
    picture?: IPicture;
    html?: string;
  };
  priority?: boolean;
}>();
</script>

<style lang="scss" scoped>
.def-banner-media {
}
</style>
